import client from "api/config";
import { convertNum } from "helper/convert-num";

const statUrl = "/admin/stat";
export const getUnReadStatRequest = () => client.get(statUrl);
